import React from 'react'
import { Link } from 'react-router-dom'

function Card({ link, count, title, bg_color, footer_color, icon }) {

    return (
        <Link to={link}
            state={{
                filter: link == '/sub-orders' && bg_color == '#17a2b8' ? 'today' : 'nextday',
                tomorrowSubOrder : link == '/sub-orders' && bg_color == '#dc3545' ? 'tomorrow-day' : '',
                thisMonthOrder : link == '/orders' && bg_color == '#28a745' ? 'this-month' : '',
            }}
            className="col-lg-3 col-6" style={{ cursor: "pointer", marginBottom: "40px" }}
        >
            <div className="small-box bg-info" style={{ marginBottom: "0", height: "100%" }}>
                <div className="inner" style={{ backgroundColor: `${bg_color}`, height: "100%" }}>
                    <h3>{count}</h3>
                    <p>{title}</p>
                </div>
                <div className="icon" style={{ backgroundColor: `${footer_color}` }}>
                    <i className={`${icon}`} />
                </div>
                <span
                    style={{ backgroundColor: `${footer_color}` }} className="small-box-footer"
                >
                    More info
                    <i className="fas fa-arrow-circle-right ml-1"
                    />
                </span>
            </div>
        </Link>
    )
}

export default Card